import { Modal } from 'antd'
import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: flex-start;
  background: var(--color-bg);
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  gap: 24px;
  max-height: 851px;
`
export const PopUp = styled(Modal)`
  width: 411px !important;
  background-color: var(--color-bg);
  border-radius: 4px;
`

export const PopUpMessage = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  width: 90%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding-right: 10px;
`
export const PopUpButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 20px;
`
